import React from 'react';
import logo from '../logo.svg';

export const HomeButton: React.FC<{}> = () => {
  return (<div className='clicky' onClick={() => (document.location.href = '/')}>
  <div className="logo-container">
    <img
      src={logo}
      alt="Startup Logo"
      className="startup-logo"
      width={"30px"}
    />
    <h2 style={{margin:0, marginTop: "6px"}}>TS</h2>
  </div>
</div>);
}